import { render } from "./LocalePicker.vue?vue&type=template&id=d7c341d6&ts=true"
import script from "./LocalePicker.vue?vue&type=script&lang=ts"
export * from "./LocalePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__